import React, { useEffect, useState } from 'react';
import { LevelProgress, AttendanceStats } from '../../../api/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire, faTrophy, faStar } from '@fortawesome/free-solid-svg-icons';
import './GamifiedLevelHeader.css';

interface GamifiedLevelHeaderProps {
    levelProgress: LevelProgress;
    attendanceStats: AttendanceStats;
}

const GamifiedLevelHeader: React.FC<GamifiedLevelHeaderProps> = ({ levelProgress, attendanceStats }) => {
    const [offset, setOffset] = useState(2 * Math.PI * 45);
    const { promotion, progressPercentage } = levelProgress;
    const radius = 45;
    const circumference = 2 * Math.PI * radius;

    useEffect(() => {
        // Animate progress circle on mount
        const progressOffset = circumference - (progressPercentage / 100) * circumference;
        setOffset(progressOffset);
    }, [progressPercentage, circumference]);

    // Extract initials for avatar placeholder
    const getInitials = (name: string) => {
        // Assuming 'name' here might be the style name if we don't have user name
        // Ideally pass user name or avatar URL if available
        return name.slice(0, 2).toUpperCase();
    };


    return (
        <div className="gamified-level-header">
            <div className="header-content">
                <div className="level-circle-container">
                    <svg className="level-circle-svg" viewBox="30 30 100 100">
                        <circle
                            className="level-circle-bg"
                            cx="80"
                            cy="80"
                            r={radius}
                        />
                        <circle
                            className="level-circle-progress"
                            cx="80"
                            cy="80"
                            r={radius}
                            style={{ strokeDasharray: circumference, strokeDashoffset: offset }}
                        />
                    </svg>
                    <div className="level-avatar">
                        <div className="level-avatar-placeholder">
                            {/* Use Style Name initials or something appropriate */}
                            {promotion.styleName ? getInitials(promotion.styleName) : 'EU'}
                        </div>
                    </div>
                </div>

                <div className="level-info-column">
                    <div className="current-style">{promotion.styleName}</div>
                    <h2 className="current-level-name">{promotion.nextLevelName || promotion.levelName}</h2>
                    <div className="achieved-level-sub">
                        Current level
                    </div>

                    <div className="simple-stat-badge">
                        <FontAwesomeIcon icon={faTrophy} className="stat-icon" />
                        <span className="stat-text">
                            <strong>{attendanceStats.attendanceByStyle[promotion.styleName] || 0}</strong> Classes
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GamifiedLevelHeader;
